import React from "react";

// Types
import Question from "../../types/Question";

// Components
import { InputFactory } from "../Factories/Input";

export default class ImageProfile extends React.Component<any, any> {
  constructor(props: Question) {
    super(props);

    this.state = {
      value: "",
      uploadValue: "",
      thumbImgPath: this.props.value && typeof this.props.value === "string" ? this.props.value : "assets/profile_noimage1.png",
      modalOpen: false,
      modalImgPath: "",
    };
  }

  render() {
    return (
      // @ts-ignore
      <div>
        <h3>{this.props.attr?.profileImageHeading}</h3>
        <p>{this.props.attr?.profileImageText}</p>
        <div className="input__container input__container--type-image">
          <InputFactory
            type="image"
            confirmModal={false}
            id={this.props.name}
            name={this.props.name}
            value={this.state.value}
            className={this.props.className}
            cropper={this.props.attr?.cropper}
            accept={"image/*"}
            onChange={this.props.onIonChange}
          />
        </div>
      </div>
    );
  }

  inputChange = (e: any) => {
    this.setState({
      uploadValue: e.detail.value,
      modalImgPath: URL.createObjectURL(e.detail.value),
      modalOpen: true,
    });
  };
}
